import React from 'react'
import { Button, Modal } from '@tecsinapse/cortex-react'
import { FormProvider } from 'react-hook-form'
import { Trans } from '@lingui/react/macro'
import { BibliotecaDialogProps } from '../types/types'
import { t } from '@lingui/core/macro'
import { useAlterarProprietarioDialog } from '../hooks/use-alterar-proprietario-dialog'
import { Usuario } from '../../../core/types/graphql'
import { FormSingleAutocomplete } from '../../hook-form-connectors/form-single-autocomplete'
import { USUARIOS_STARTS_WITH } from '../../grupo-usuarios-edicao/data/usuarios-starts-with'

export const AlterarProprietarioDialog = ({
  open,
  close,
  pastaAtual
}: BibliotecaDialogProps) => {
  const { form, onSubmit, handleCloseForm } = useAlterarProprietarioDialog({
    pastaAtual,
    close
  })

  const { handleSubmit, formState } = form
  const { isSubmitting, isDirty } = formState

  return (
    <FormProvider {...form}>
      <Modal onClose={handleCloseForm} open={open}>
        <div className={'w-100 flex flex-col items-start'}>
          <p className={'text-h3 font-bold mb-deca'}>
            <Trans>Alterar Proprietário</Trans>
          </p>
          <form onSubmit={handleSubmit(onSubmit)} className={'w-full'}>
            <div className={'flex flex-col space-y-deca'}>
              <FormSingleAutocomplete
                name='proprietario'
                label={t`Nome ou e-mail do proprietário`}
                popoverClassName='max-h-[10rem] overflow-y-scroll'
                query={USUARIOS_STARTS_WITH}
                queryVariable='nome'
                isQueryAutocomplete
                filterOptions={(it: Usuario) =>
                  pastaAtual.proprietario?.id !== it.id
                }
                dataPath='usuariosByNomeOrEmailStartingWith'
                optionSelectFromT={(it: Usuario) => ({
                  value: `${it.email}`,
                  label: `${it.nome} (${it.email})`
                })}
              />
              <div className={'flex flex-row justify-between items-center'}>
                <Button
                  disabled={form.formState.isSubmitting}
                  type='button'
                  onClick={handleCloseForm}
                  variants={{ variant: 'outline', className: 'w-full' }}
                >
                  <Trans>Cancelar</Trans>
                </Button>
                <Button
                  disabled={isSubmitting || !isDirty}
                  type='submit'
                  variants={{ className: 'w-full' }}
                >
                  <Trans>Alterar</Trans>
                </Button>
              </div>
            </div>
          </form>
        </div>
      </Modal>
    </FormProvider>
  )
}
